import Spinner from "react-bootstrap/Spinner";

const PageLoader = () => {
  return (
    <div className="loader">
        <Spinner animation="grow" />
    </div>
  );
};

export default PageLoader;
